module.exports = __webpack_public_path__ + "static/media/Test45.a5f3e127.bmp";